// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"iH-z","carouselContainer":"jH-z"};